import CodiciCollegiCamera from '@/data/codici_cl_uni_CAM.json';
import CodiciCollegiSenato from '@/data/codici_cl_uni_SEN.json';
import { StructureType } from './model';

export const getCodCollegio = (cod_cl_uni: string, type: StructureType) => {
  if (type === StructureType.CAMERA) {
    return (
      CodiciCollegiCamera.find(c => c.cod_cl_uni === cod_cl_uni.toString())
        ?.COD_CU20 || null
    );
  }
  return (
    CodiciCollegiSenato.find(c => c.cod_cl_uni === cod_cl_uni.toString())
      ?.SU20_COD || null
  );
};
